<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form #flujoVentaForm [formGroup]="formFlujoVentaPaso" (ngSubmit)="onSubmit()">

    <!-- Fila 1: Código | Nombre | Naturaleza -->
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_CODIGO' | translate }}</label>
          <label class="falso-combo-texto">{{ f.codigo.value }}</label>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_NOMBRE' | translate }}</label>
          <input type="text" pInputText id="nombre-{{tabView.codigo}}"
                 name="nombre"
                 autocomplete="off"
                 formControlName="nombre"
                 maxlength="50"
                 capitalize-reactive>
          <div class="p-message p-messages-error p-corner-all" *ngIf="formSubmitted && !f.nombre.valid">
            {{ 'FLUJOVENTATABVIEW.LBL_NOMBRE' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" *ngIf="tabView.codigo !== pasosEnum.FINPROCESO">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate }}</label>
          <p-multiSelect id="idTipoPersona{{tabView.codigo}}" name="nomTipoPersona{{tabView.codigo}}" [options]="listaTiposPersonas"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idsNaturaleza"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="formSubmitted && f.idsNaturaleza.invalid">
            {{ 'FLUJOVENTA.LBL_NATURALEZA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 2: Secuencia | Tipo de vinculación | Tipo de Ocupación (cuando aplica) -->
    <div class="grid form-group">
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_SECUENCIA' | translate }}</label>
          <p-dropdown disableTab id="secuencia" name="secuencia" [options]="listaSecuencias"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}" *ngIf="!secFija"
                      formControlName="secuencia"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
          ></p-dropdown>
          <label class="falso-combo-texto" *ngIf="secFija">{{f.secuencia.value}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="formSubmitted && !f.secuencia.valid">
            {{ 'FLUJOVENTATABVIEW.LBL_SECUENCIA' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_VINCULACION' | translate }}</label>
          <p-multiSelect id="vinculacion" name="vinculacion" [options]="listaVinculaciones" filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idVinculacion"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="formSubmitted && !f.idVinculacion.valid">
            {{ 'FLUJOVENTATABVIEW.LBL_VINCULACION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-4 lg:col-4" id="tipo-ocupacion-field" *ngIf="tabView.codigo !== pasosEnum.DATOSBASICOS && tabView.codigo !== pasosEnum.FINPROCESO && f.indicadorOcupacion.value">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_TIPOOCUPACION' | translate }}</label>
          <p-multiSelect id="idsOcupacion" name="idsOcupacion" [options]="listaTiposOcupacionesConfig"
                         filter="filter"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}"
                         formControlName="idsOcupacion"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="formSubmitted && f.idsOcupacion.invalid">
            {{ 'FLUJOVENTATABVIEW.LBL_TIPOOCUPACION' | translate }} {{ 'LBL_REQUERIDO' | translate }}
          </div>
        </div>
      </div>
    </div>

    <!-- Fila 3: Descripción | Habilitado -->
    <div class="grid form-group align-items-center">
      <div class="col-12 md:col-9 lg:col-9">
        <div class="div-form">
          <label>{{ 'FLUJOVENTATABVIEW.LBL_DESCRIPCION' | translate }}</label>
          <textarea pInputTextarea id="descripcion-{{tabView.codigo}}" name="descripcion" formControlName="descripcion"
                    maxlength="250" capitalize-reactive></textarea>
        </div>
      </div>
      <div class="col-12 md:col-3 lg:col-3 flex align-items-center justify-content-center gap-2">
        <p-inputSwitch formControlName="indicadorHabilitado" inputId="indicadorHabilitado"></p-inputSwitch>
        <label for="indicadorHabilitado" class="mb-0" style="cursor:pointer">{{ 'LBL_HABILITADO' | translate }}</label>
      </div>
    </div>

    <!-- Fila checkboxes + Ícono -->
    <div class="grid form-group">
      <div class="col-12">
        <div class="flex flex-wrap align-items-center gap-4"
             style="background-color: #f7f7f7; border-radius: 6px; padding: 0.75rem 1rem;">

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_PASOPRINCIPAL' | translate}}" binary="true"
                      id="indicadorPasoPrincipal"
                      formControlName="indicadorPasoPrincipal"></p-checkbox>

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_PREAPROBADO' | translate}}" binary="true"
                      id="indicadorPreaprobado"
                      formControlName="indicadorPreaprobado"></p-checkbox>

          <p-checkbox *ngIf="tabView.codigo !== pasosEnum.DATOSBASICOS && tabView.codigo !== pasosEnum.FINPROCESO"
                      label="{{ 'FLUJOVENTATABVIEW.LBL_OCUPACION' | translate}}" binary="true"
                      id="indicadorOcupacion"
                      formControlName="indicadorOcupacion"></p-checkbox>

          <p-checkbox label="{{ 'FLUJOVENTATABVIEW.LBL_GESTORTERCEROS' | translate}}" binary="true"
                      id="indicadorGestorTerceros"
                      formControlName="indicadorGestorTerceros"></p-checkbox>

          <p-checkbox *ngIf="HabilitarindicadorVinculacionPorPerfil"
                      label="{{ 'FLUJOVENTATABVIEW.LBL_VINCULACIONPORPERFIL' | translate}}" binary="true"
                      id="indicadorVinculacionPerfil"
                      formControlName="indicadorVinculacionPerfil"></p-checkbox>

          <!-- Adjunto inline -->
          <div class="flex align-items-center gap-2 ml-auto">
            <label class="mb-0 font-bold">{{ 'FLUJOVENTA.LBL_ICONO' | translate }}</label>
            <img *ngIf="!subAdjunto && imagen"
                 style="height: 32px; border-radius: 4px; filter: invert(57%) sepia(68%) saturate(450%) hue-rotate(83deg) brightness(96%) contrast(90%);"
                 [src]="imagen" alt=""/>
            <div class="adjuntar-outlined">
              <p-fileUpload name="file" url="{{svcThUrl}}" [auto]="false"
                            chooseLabel="{{'BTN_ADJUNTAR' | translate}}"
                            chooseIcon="pi pi-paperclip"
                            (onBeforeUpload)="onBeforeSend($event)" mode="basic" [hidden]="subAdjunto"
                            (onValidSelect)="onSelect($event, $event.files)" fSize
                            (onUpload)="onUpload($event)" accept="image/*"
              ></p-fileUpload>
            </div>
            <div *ngIf="subAdjunto" class="flex align-items-center gap-1">
              <i class="fa fa-refresh fa-spin fa-fw"></i>
              <span>{{'LBL_CARGANDO' | translate }}</span>
            </div>
            <span *ngIf="f.idAdjunto.value && !subAdjunto" class="flex align-items-center gap-1">
              <i class="fa fa-file-o" aria-hidden="true"></i>
              <span style="max-width: 140px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{nomArchivo}}</span>
              <a (click)="eliminarAdjunto()" style="cursor:pointer; color: #dc3545; padding: 0 4px;">
                <i class="fa fa-times" aria-hidden="true"></i>
              </a>
            </span>
          </div>

        </div>
      </div>
    </div>

    <!-- Sección de controles (condicional) -->
    <div class="grid form-group" *ngIf="showControlesTable">
      <div class="col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_CODIGOSECCION' | translate }}</label>
          <label class="falso-combo-texto">{{ funcionalidadControl?.codigo }}</label>
        </div>
      </div>
      <div class="col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTATABVIEW.LBL_SECCION' | translate }}</label>
          <label class="falso-combo-texto">{{ funcionalidadControl?.nombre }}</label>
        </div>
      </div>
    </div>

    <app-datatable-controles *ngIf="showControlesTable"
                             [listaFuncionalidadesControles]="tabView.controles"
                             [pasoFlujo]="tabView.codigo.toLowerCase()">
    </app-datatable-controles>

    <div class="grid form-footer-buttons" *ngIf="!procesando">
      <div class="form-group col-12">
        <a (click)="cancelar(formFlujoVentaPaso.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-floppy-o" label="{{'BTN_GUARDAR' | translate}}"
                type="submit" pButton [disabled]="inhabilitarBotonGuardar"></button>
      </div>
    </div>
    <div class="grid" *ngIf="procesando">
      <div class="col-12 md:col-12 lg:col-12 text-center">
        <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
        <span>{{'LBL_PROCESANDO' | translate }}</span>
      </div>
    </div>
  </form>
</div>

<p-confirmDialog #cd key="form-paso-flujo-{{tabView.codigo}}">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
